'use strict';

var React = require('react'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    TransitionEventsMixin = require('../mixins/TransitionEventsMixin');

/**
 * This is just like <img /> but with onTransitionEnd event
 * that React doesn't support out of the box.
 */
var Img = React.createClass({
  mixins: [TransitionEventsMixin, PureRenderMixin],

  propTypes: {
    onTransitionEnd: React.PropTypes.func.isRequired,
    preventSave: React.PropTypes.bool.isRequired
  },

  getDefaultProps: function () {
    return {
      preventSave: true
    };
  },

  render: function () {
    return (
      <img {...this.props}
           onContextMenu={this.handleContextMenu}
           onDragStart={this.handleDragStart} />
    );
  },

  handleTransitionEnd: function () {
    this.props.onTransitionEnd();
  },

  handleContextMenu: function (e) {
    if (this.props.preventSave) {
      e.preventDefault();
    } else if (this.props.onContextMenu) {
      this.props.onContextMenu(e);
    }
  },

  handleDragStart: function (e) {
    if (this.props.preventSave) {
      e.preventDefault();
    } else if (this.props.onDragStart) {
      this.props.onDragStart(e);
    }
  },
});

module.exports = Img;


/** WEBPACK FOOTER **
 ** ./atoms/Image.jsx
 **/